/* eslint-disable */
import { createApp } from 'vue'
import './registerServiceWorker'
import 'driver.js/dist/driver.css'
import './style/app.scss'
import 'bootstrap'
import api from '@/services/api';
import format from '@/utils/format';
//@ts-ignore
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import ColorPicker from 'primevue/colorpicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Chart from 'primevue/chart';
import Paginator from 'primevue/paginator';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Tooltip from 'primevue/tooltip';
//@ts-ignore
import CashierLayout from '@/layouts/CashierLayout.vue';
//@ts-ignore
import AdminLayout from '@/layouts/AdminLayout.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import SettingsLayout from '@/layouts/SettingsLayout.vue';
import * as excelExport from '@/utils/excelExport';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import AppLoadingButton from '@/components/AppLoadingButton.vue';
import BootstrapDataTable from '@/components/BootstrapDataTable.vue';
import ModuleActivityButton from '@/components/ModuleActivityButton.vue';
import MaintenanceView from '@/views/MaintenanceView.vue';
import { isMaintenanceModeEnabled } from '@/config/app';
import { startAccordingToMaintenanceMode } from '@/support/maintenanceRuntime';
import { checkForLatestSpaVersion } from '@/support/appVersionRefresh';

let applicationStarted = false;

const startApplication = () => {
  if (applicationStarted) return;
  applicationStarted = true;

store.dispatch('shop/LOAD_FROM_LOCALSTORAGE');
store.dispatch('cashRegister/LOAD_FROM_LOCALSTORAGE');
store.dispatch('userSettings/LOAD_FROM_LOCALSTORAGE');
// La configuration bloque le rendu des layouts dans App.vue jusqu'à sa réception.
// L'overlay global reste affiché et permet une nouvelle tentative en cas d'erreur.
store.dispatch('runtime/load').catch(() => undefined);
if (/^\/backoffice(?:\/|$)/.test(window.location.pathname) && store.getters['auth/isAuthenticated'] && !store.getters['auth/currentUser']?.must_change_password) {
  store.dispatch('userSettings/load').catch(() => undefined);
}

const app = createApp(App);
app.use(PrimeVue);
app.use(store);
app.use(router);
app.use(ConfirmationService);
app.config.globalProperties.$confirmAction = function (options: any) {
  const config = typeof options === 'string' ? { message: options } : (options || {});
  const message = String(config.message || '').toLowerCase();
  const isDestructive = ['supprimer', 'annuler', 'désactiver', 'retirer', 'fermer', 'clôturer'].some((word) =>
    message.includes(word)
  );

  return new Promise((resolve) => {
    let isSettled = false;
    const finish = (value: boolean) => {
      if (isSettled) return;
      isSettled = true;
      resolve(value);
    };

    this.$confirm.require({
      header: config.header || 'Confirmation',
      message: config.message || '',
      icon: config.icon || 'pi pi-exclamation-triangle',
      acceptLabel: config.acceptLabel || 'Confirmer',
      rejectLabel: config.rejectLabel || 'Annuler',
      acceptIcon: config.acceptIcon || 'fa fa-check',
      rejectIcon: config.rejectIcon || 'fa fa-xmark',
      acceptClass: config.acceptClass || (isDestructive ? 'p-button-danger' : 'p-button-primary'),
      rejectClass: config.rejectClass || 'p-button-secondary p-button-text',
      accept: () => finish(true),
      reject: () => finish(false),
      onHide: () => finish(false),
    });
  });
};
app.component('CashierLayout', CashierLayout);
app.component('AdminLayout', AdminLayout);
app.component('BaseLayout', BaseLayout);
app.component('SettingsLayout', SettingsLayout);
app.component('AppLoadingButton', AppLoadingButton);
app.component('BootstrapDataTable', BootstrapDataTable);
app.component('ModuleActivityButton', ModuleActivityButton);
app.component('PrimevueConfirmDialog', ConfirmDialog);
app.component('PrimevueDataTable', DataTable);
app.component('PrimevueColumn', Column);
app.component('PrimevueDialog', Dialog);
app.component('PrimevueInputText', InputText);
app.component('PrimevueDropdown', Dropdown);
app.component('PrimevueCheckbox', Checkbox);
app.component('PrimevueColorPicker', ColorPicker);
app.component('PrimevueInputNumber', InputNumber);
app.component('PrimevueTextarea', Textarea);
app.component('PrimevueChart', Chart);
app.component('PrimevuePaginator', Paginator);
app.component('PrimevueTabPanel', TabPanel);
app.component('PrimevueTabView', TabView);
app.directive('tooltip', Tooltip);

app.config.globalProperties.$api = api;
app.config.globalProperties.$format = format;
app.config.globalProperties.$excel = excelExport;

app.mount('#app');
};

const startMaintenance = () => {
  const maintenanceApp = createApp(MaintenanceView, {
    onMaintenanceEnded: () => {
      maintenanceApp.unmount();
      startApplication();
    },
  });
  maintenanceApp.mount('#app');
};

const startWithMaintenanceState = () => {
  startAccordingToMaintenanceMode(isMaintenanceModeEnabled(), startApplication, startMaintenance);
};

checkForLatestSpaVersion()
  .then((result) => {
    if (result !== 'reloading') startWithMaintenanceState();
  })
  .catch(startWithMaintenanceState);
